/**
 *
 * The experiments duck. Default export is the reducer
 *
 * Action Types:
 * - EXPERIMENTS_REQUESTED
 * - EXPERIMENTS_SUCCEEDED
 * - EXPERIMENTS_REQUEST_FAILED
 *
 * Action Creators:
 * - requestExperiments
 * - experimentsSucceeded
 * - experimentsRequestFailed
 */

import get from 'lodash/get';
import type {
  ExperimentsState,
  ExperimentsAction,
  ExperimentsRequested,
  ExperimentsRequestFailed,
  ExperimentsSucceeded,
  Election,
  SetExperimentsUUID,
} from '../types/experiments';

/** @type {ActionType} */
export const EXPERIMENTS_REQUESTED = 'PB/experiments/EXPERIMENTS_REQUESTED';

/** @type {ActionType} */
export const EXPERIMENTS_SUCCEEDED = 'PB/experiments/EXPERIMENTS_SUCCEEDED';

/** @type {ActionType} */
export const EXPERIMENTS_REQUEST_FAILED =
  'PB/experiments/EXPERIMENTS_REQUEST_FAILED';

/** @type {ActionType} */
export const SET_EXPERIMENTS_UUID = 'PB/experiments/SET_EXPERIMENTS_UUID';

export const initialState = {
  loading: false,
  uuid: '',
  tests: {},
};

/** @ignore */
export default function experiments(
  state: ExperimentsState = initialState,
  action: ExperimentsAction,
): ExperimentsState {
  switch (action.type) {
    case EXPERIMENTS_REQUESTED:
      return { ...state, loading: true };
    case EXPERIMENTS_SUCCEEDED:
      const election = get(action, 'payload.election', {});
      return {
        ...state,
        tests: { [election.feature_slug]: election },
        loading: false,
      };
    case EXPERIMENTS_REQUEST_FAILED:
      return { ...state, loading: false };
    case SET_EXPERIMENTS_UUID:
      const uuid = get(action, 'payload.uuid');
      return { ...state, uuid };
    default:
      return state;
  }
}

/**
 * Creates a EXPERIMENTS_REQUESTED action
 *
 * @return {Action}
 * @property {string} type EXPERIMENTS_REQUESTED
 */
export function requestExperiments(feature_slug: string): ExperimentsRequested {
  return {
    type: EXPERIMENTS_REQUESTED,
    payload: { feature_slug },
  };
}

/**
 * Creates a EXPERIMENTS_SUCCEEDED action
 *
 * @return {Action}
 * @property {string} type EXPERIMENTS_SUCCEEDED
 * @property {Object} payload
 */
export function experimentsSucceeded(election: Election): ExperimentsSucceeded {
  return {
    type: EXPERIMENTS_SUCCEEDED,
    payload: { election },
  };
}

/**
 * Creates a EXPERIMENTS_REQUEST_FAILED action
 *
 * @return {Action}
 * @property {string} type EXPERIMENTS_REQUEST_FAILED
 * @property {Object} payload
 */
export function experimentsRequestFailed(
  feature_slug: string,
  error: string,
): ExperimentsRequestFailed {
  return {
    type: EXPERIMENTS_REQUEST_FAILED,
    payload: { message: `Election for ${feature_slug} failed: ${error}` },
  };
}

export function setExperimentsUUID(uuid: string): SetExperimentsUUID {
  return {
    type: SET_EXPERIMENTS_UUID,
    payload: { uuid },
  };
}
